import { render, staticRenderFns } from "./PatientChatSection.vue?vue&type=template&id=051b00b0"
import script from "./PatientChatSection.vue?vue&type=script&lang=js"
export * from "./PatientChatSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports